// extracted by mini-css-extract-plugin
export var deliveryRow = "_mw-a";
export var fixedHeight = "_mw-4";
export var freightLogo = "_mw-9";
export var fullWidth = "_mw-3";
export var priceColumn = "_mw-5";
export var radioSelected = "_mw-7";
export var radioUnselected = "_mw-6";
export var selectedOption = "_mw-2";
export var selectedOptionContainer = "_mw-1";
export var selection = "_mw-0";
export var tallSkeletonText = "_mw-8";